const CURRENCY_SYMBOL: Record<string, string> = {
  CNY: "¥",
  USD: "$",
  EUR: "€",
  GBP: "£",
  SGD: "S$",
  HKD: "HK$",
  CHF: "CHF",
  JPY: "¥",
  CAD: "CA$",
  AUD: "A$",
  KRW: "₩",
  NZD: "NZ$",
};

/** 原始币种及金额，例如 USD $300.00 */
export function formatOriginalAmount(currency: string, amount: number) {
  const symbol = CURRENCY_SYMBOL[currency] ?? "";
  const money = Number(amount || 0).toFixed(2);
  if (!currency) return `${symbol}${money}`;
  return symbol ? `${currency} ${symbol}${money}` : `${currency} ${money}`;
}
